import { defaultLayout } from '@app/router/utils';
import { getFederationComponent } from '@src/federations/getFederationComponent';
import UserSelectionsContainer from '@modules/sportOffer/UserSelectionsContainer.vue';
import SdsSportsSidebar from '@app/shared/modules/sportOffer/SdsSportsSidebar.vue';
import SuperSocialMobileHeader from '@socialFederation/shared/SuperSocialMobileHeader.vue';

export const superSocialPage = {
    ...defaultLayout,
    mobileHeader: SuperSocialMobileHeader,
    content: getFederationComponent(() => import('social/SuperSocial')),
    rightSidebar: UserSelectionsContainer,
    leftSidebar: SdsSportsSidebar,
    mobileBottomContent: UserSelectionsContainer,
};
